import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiZap, FiX } from 'react-icons/fi';

const FeatureBlockedBanner = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const handler = (e) => setMessage(e.detail?.message || "Your current plan doesn't include this feature.");
    window.addEventListener('feature:blocked', handler);
    return () => window.removeEventListener('feature:blocked', handler);
  }, []);

  if (!message) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: '#1f2937',
        color: 'white',
        borderRadius: '10px',
        padding: '0.9rem 1.1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
        maxWidth: '480px',
      }}
    >
      <FiZap size={18} style={{ flexShrink: 0, color: '#fbbf24' }} />
      <span style={{ fontSize: '0.88rem', lineHeight: 1.4 }}>{message}</span>
      <button
        onClick={() => { setMessage(null); navigate('/pricing'); }}
        style={{
          flexShrink: 0, background: '#0ea5e9', color: 'white', border: 'none',
          borderRadius: '6px', padding: '0.5rem 0.9rem', fontSize: '0.82rem',
          fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
        }}
      >
        View Plans
      </button>
      <button
        onClick={() => setMessage(null)}
        aria-label="Dismiss"
        style={{ flexShrink: 0, background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '0.2rem' }}
      >
        <FiX size={16} />
      </button>
    </div>
  );
};

export default FeatureBlockedBanner;